// @flow
import React, { Component, Fragment } from "react";
import NumberFormat from "react-number-format";

import {
  StyledTextField,
  StyledSelect,
  SingleCheckBox
} from "imagus-components";
import AddressBlock from "./AddressBlock";

import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

function NumberFormatCustom(props: *): React$Element<*> {
  const { inputRef, onChange, name, ...other } = props;

  return (
    <NumberFormat
      {...other}
      ref={(ref: *): * => {
        inputRef(ref ? ref.inputElement : null);
      }}
      onValueChange={(values: *): * => {
        onChange({
          currentTarget: {
            value: values.formattedValue,
            name: name
          }
        });
      }}
      format="(+##) # #### #### #######"
      mask=" "
      type="tel"
    />
  );
}

type CompanyBasicFieldsPropsType = {
  company_name: string,
  abn: string,
  address: string,
  suburb: string,
  postcode: string,
  city: string,
  state: string,
  other_state: string,
  country: string,
  contact_name: string,
  contact_email: string,
  contact_number: string,
  notes: string,
  company_type: string,
  authorised_reseller: boolean,
  handleTextChange: Function,
  handleSelectChange: Function,
  handleCheckBoxChange: Function,
  emailInvalid: boolean,
  phoneInvalid: boolean,
  companyInvalid: boolean,
  hasCompanyType: boolean,
  companyTypes: Array<*>
};

class CompanyBasicFields extends Component<CompanyBasicFieldsPropsType, *> {
  render(): React$Element<*> {
    return (
      <Fragment>
        <Grid item xs={12} md={6}>
          <StyledTextField
            isRequired={true}
            label="Company Name"
            name="company_name"
            value={this.props.company_name}
            onChange={this.props.handleTextChange}
            inpuType="text"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledTextField
            isRequired={false}
            label="ABN No."
            name="abn"
            value={this.props.abn}
            onChange={this.props.handleTextChange}
            inpuType="text"
          />
        </Grid>
        <AddressBlock
          title="Address"
          address={this.props.address}
          suburb={this.props.suburb}
          postcode={this.props.postcode}
          city={this.props.city}
          state={this.props.state}
          other_state={this.props.other_state}
          country={this.props.country}
          handleTextChange={this.props.handleTextChange}
          handleSelectChange={this.props.handleSelectChange}
        />
        <Card style={{ width: "100%" }} className="top-margin-10">
          <CardContent>
            <Typography variant="h6">Contact Person</Typography>
            <Grid container spacing={8}>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  isRequired={true}
                  label="Name"
                  name="contact_name"
                  value={this.props.contact_name}
                  onChange={this.props.handleTextChange}
                  inpuType="text"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  isRequired={true}
                  label="Email"
                  name="contact_email"
                  value={this.props.contact_email}
                  onChange={this.props.handleTextChange}
                  inpuType="text"
                  isInvalid={this.props.emailInvalid}
                />
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  isRequired={true}
                  label="Phone Number"
                  name="contact_number"
                  value={this.props.contact_number}
                  onChange={this.props.handleTextChange}
                  inpuType="text"
                  inputComponent={NumberFormatCustom}
                  helper="(+61) 7 1234 5678"
                  isInvalid={this.props.phoneInvalid}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Grid item xs={12}>
          <StyledTextField
            isRequired={false}
            label="Notes"
            name="notes"
            value={this.props.notes}
            onChange={this.props.handleTextChange}
            inpuType="text"
            rows={4}
          />
        </Grid>
        {this.props.hasCompanyType && (
          <Fragment>
            <Grid item xs={12} md={6}>
              <StyledSelect
                value={this.props.company_type}
                onChange={this.props.handleSelectChange}
                name="company_type"
                label="Company Type"
                isRequired={true}
                menus={this.props.companyTypes}
                isStyled
                isInvalid={this.props.companyInvalid}
              />
            </Grid>
            {this.props.company_type === "RESELLER" ? (
              <Grid item xs={12} md={6} className="top-margin-25">
                <SingleCheckBox
                  name="authorised_reseller"
                  value={this.props.authorised_reseller}
                  onChange={this.props.handleCheckBoxChange}
                  label="Authorised Reseller"
                />
              </Grid>
            ) : (
              <Grid item xs={12} md={6} />
            )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default CompanyBasicFields;
